import React from 'react'
import SpinnerUI from '../output/SpinnerUI'
import './Switch.css'

const SwitchUI = ({rowId, label, className, checked, onChange, withSpinner, busy}) =>
  <label className={`w_switch g_flex_h ${className}`}>
    {
      label &&
      <span className='g_m_right_50'>{label}</span>
    }
    {
      withSpinner &&
      <SpinnerUI show={busy} reserveSpace={true} />
    }
    <div className='inner'>
      <input type="checkbox" checked={checked} data-row-id={rowId} onChange={onChange} />
      <span className="slider round"></span>
    </div>
  </label>

export default SwitchUI
